// for multiple requests
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const applyRefreshTokenInterceptor = (
  instanceRef,
  updateAuthData,
  onRefreshFail
) => {
  instanceRef.instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;
      if (
        (error.response?.status === 401 || error.response?.status === 403) &&
        !originalRequest.isRetry
      ) {
        if (isRefreshing) {
          return new Promise(function test(resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return instanceRef.instance(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest.isRetry = true;
        isRefreshing = true;

        return new Promise(function test(resolve, reject) {
          instanceRef.instance
            .post('auth/refresh')
            .then((responseToken) => {
              if (responseToken?.data?.data) {
                updateAuthData(responseToken);
                const { AuthenticationResult } = responseToken.data.data;
                const { AccessToken } = AuthenticationResult;
                // eslint-disable-next-line no-param-reassign
                instanceRef.instance.defaults.headers.common.Authorization = `Bearer ${AccessToken}`;
                originalRequest.headers.Authorization = `Bearer ${AccessToken}`;
                processQueue(null, AccessToken);
                resolve(instanceRef.instance(originalRequest));
              } else {
                processQueue('Error al recuperar la sesión', null);
                reject(new Error('Error al recuperar la sesión'));
                onRefreshFail();
              }
            })
            .catch((err) => {
              processQueue(err, null);
              reject(err);
              onRefreshFail();
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }

      return Promise.reject(error);
    }
  );
};

export default applyRefreshTokenInterceptor;
